import React, { useEffect, useState } from "react";
import { getreport } from "../../api/api";
import Renderhtml from "../../components/Renderhtml";

const Checklisterror = () => {
  const [data, setData] = useState(null);

  // let para = `Epub-Validation/TEMP/OEBPS/content.opf => Certified information "<meta property="a11y:certifiedBy" not matching with our criteria.Epub-Validation/TEMP/OEBPS/content.opf => Certified information "<meta property="a11y:certifiedBy" not matching with our criteria.Epub-Validation/TEMP/OEBPS/content.opf => Certified information "<meta property="a11y:certifiedBy" not matching with our criteria.`;

  useEffect(() => {
    fetchdata();
  }, []);

  const fetchdata = async (currentFileId) => {
    try {
      let data = await getreport();
      if (data.data) {
        setData(data.data.tags);
      } else {
        alert(data.error);
      }
    } catch (e) {
      alert(e);
    }
  };

  console.log(data);

  return (
    <div className="flex flex-col w-full">
      <div className="p-8 flex flex-col gap-8 h-[100%] min-h-[70vh]">
        <div className="flex w-full justify-between text-left items-center">
          <h1 className="text-24 font-semibold">Checklist Errors</h1>
        </div>
        <div className="overflow-auto max-h-[600px] rounded-[16px] border-[1px] border-commonborder shadow-commonshadow">
          <table className="w-full ">
            <thead className="bg-tableheadingbg px-4 py-6 text-left text-white text-16 font-semibold sticky top-0">
              <tr className="">
                <th className="px-4 py-5">S.No</th>
                <th className="px-4 py-5 w-full">Error</th>
              </tr>
            </thead>
            <tbody className="w-full text-left bg-white">
              <tr className="border-b-[1px] border-commonborder last:border-none">
                <td className="px-4 py-5 w-1/12">
                  <p className="px-4 py-3 rounded-[8px]">1</p>
                </td>
                <td className="px-4 py-5 overflow-hidden">
                  <p className="mx-4 py-3 rounded-[8px] text-ellipsis whitespace-nowrap">
                    <Renderhtml data={data} />
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Checklisterror;
